import React, {useState} from "react";
import {ReactComponent as LinkIcon} from "@assets/icons/link.svg";
import {classNames} from "@utils/class-names";

interface LinkProps {
    isActive: boolean;
    currentLinkUrl: string | null;
    onInsertLink: (url: string) => void;
    onRemoveLink: () => void;
}

const LinkTool = (props: LinkProps) => {
    const {isActive, currentLinkUrl, onInsertLink, onRemoveLink} = props;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [linkUrl, setLinkUrl] = useState("");
    const [savedSelection, setSavedSelection] = useState<Range | null>(null);

    const handleClick = () => {
        const selection = window.getSelection();
        if (selection && selection.rangeCount > 0) {
            setSavedSelection(selection.getRangeAt(0).cloneRange());
        }
        if (currentLinkUrl) setLinkUrl(currentLinkUrl);
        setIsModalOpen(true);
    };

    const restoreSelection = () => {
        if (savedSelection) {
            const selection = window.getSelection();
            if (selection) {
                selection.removeAllRanges();
                selection.addRange(savedSelection);
            }
        }
    };

    const handleSubmit = () => {
        if (!linkUrl.trim()) return;
        restoreSelection();
        onInsertLink(linkUrl);
        setIsModalOpen(false);
        setLinkUrl("");
        setSavedSelection(null);
    };

    const handleClear = () => {
        restoreSelection();
        onRemoveLink();
        setIsModalOpen(false);
        setLinkUrl("");
        setSavedSelection(null);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setLinkUrl("");
        setSavedSelection(null);
    };

    return (
        <>
            <button
                type="button"
                onClick={handleClick}
                className={classNames(
                    "px-2 w-10 h-10 hover:bg-on-surface/5 rounded-full flex items-center justify-center",
                    isActive && "bg-primary/10 text-primary"
                )}
                title="Dodaj link"
            >
                <LinkIcon className={isActive ? "text-primary" : ""}/>
            </button>

            {isModalOpen && (
                <div
                    className="absolute left-1/2 top-full -translate-x-1/2 mt-2 bg-white rounded-2xl shadow-lg border border-gray-200 p-4 w-80 z-10">
                    <h3 className="text-sm font-semibold mb-3 text-gray-800">
                        {currentLinkUrl ? "Edytuj link" : "Dodaj link"}
                    </h3>
                    <input
                        type="url"
                        value={linkUrl}
                        onChange={(e) => setLinkUrl(e.target.value)}
                        placeholder="Wklej adres URL"
                        className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary"
                        autoFocus
                    />
                    <div className="flex justify-between gap-2 mt-4">
                        <button type="button" onClick={handleClear}
                                className="px-3 py-1.5 text-sm text-red-500 hover:text-red-600"
                                disabled={!currentLinkUrl}>
                            Wyczyść
                        </button>
                        <button type="button" onClick={handleCancel}
                                className="px-3 py-1.5 text-sm text-gray-600 hover:text-gray-800">
                            Anuluj
                        </button>
                        <button type="button" onClick={handleSubmit} disabled={!linkUrl.trim()}
                                className="px-3 py-1.5 text-sm bg-primary text-white rounded-lg hover:bg-primary/90 disabled:opacity-50">
                            Dodaj
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default LinkTool;
